import { LOGIN_URL, REGISTER_URL } from '@/lib/app-url';

/**
 * Sign-in URL carrying the one-time claim token.
 *
 * Registering was the only way out of the promotion screen, so anyone whose
 * address already had an account hit "email already registered" and lost the
 * link they had just made — the claim token is spent nowhere else. The
 * dashboard redeems a stored token after any successful sign-in, not just
 * after registering, so this route now works for them.
 */
export function claimLoginUrl(claimToken: string): string {
  return `${LOGIN_URL}?claim=${encodeURIComponent(claimToken)}`;
}

/** Register URL carrying the one-time claim token (Phase 4 consumes it). */
export function claimRegisterUrl(claimToken: string): string {
  return `${REGISTER_URL}?claim=${encodeURIComponent(claimToken)}`;
}

/** "7 October 2026" for an ISO timestamp; '' for an unparseable value. */
export function formatExpiry(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}
